module.exports = __webpack_public_path__ + "static/2-b9eea263d3e0765c5fd358e2101b3a40.png";